// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationOverflowContainerId = (z.number());
export const fermentationOverflowContainer = z.object({
    id: fermentationOverflowContainerId,
    fermentation_id: fermentationId,
    started_at: z.date(),
    ended_at: z.date().nullable(),
    container_tare_g: z.string(),
    notes: z.string().nullable(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    auto_closed_at_end_of_run: z.boolean(),
});
export const fermentationOverflowContainerInitializer = z.object({
    id: fermentationOverflowContainerId.optional(),
    fermentation_id: fermentationId,
    started_at: z.date(),
    ended_at: z.date().optional().nullable(),
    container_tare_g: z.string(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    auto_closed_at_end_of_run: z.boolean().optional(),
});
export const fermentationOverflowContainerMutator = z.object({
    id: fermentationOverflowContainerId.optional(),
    fermentation_id: fermentationId.optional(),
    started_at: z.date().optional(),
    ended_at: z.date().optional().nullable(),
    container_tare_g: z.string().optional(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    auto_closed_at_end_of_run: z.boolean().optional(),
});
//# sourceMappingURL=FermentationOverflowContainer.js.map